
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import Api from '../Services/ApiCall';
import { FaUserTie, FaUsers, FaBriefcase, FaWallet, FaCrown } from 'react-icons/fa';

const Employer_Dashboard = () => {
  const [walletAmount, setWalletAmount] = useState("Loading...");
  const [postcount, setPostcount] = useState("Loading...");
  useEffect(() => {
    getGrid();
    GetPostCount();
  }, []);
  async function getGrid() {
    var Id = sessionStorage.getItem("MUserID")
    var Param = { Mstuserregid: Id }
    var url = "/UserReg/GetUserRegtable1";
    let _response = await Api.BindGrid(Param, url)
    setWalletAmount(_response[0].Recharge_amount)
    sessionStorage.setItem('employerwalletAmount', _response[0].Recharge_amount)
  }
  async function GetPostCount() {
      var id = sessionStorage.getItem('MUserID');
      var url = "/DropDown/GetPostCount?id=" + id;
      let _response = await Api.BindDropdown(url)
      let Arry_Title1 = []; 
      setPostcount(_response[0].id)
      sessionStorage.setItem('employerPostcount', _response[0].id)
    }

  const cards = [
    {
      title: 'Employers Created',
      value: 5,
      icon: <FaUserTie />,
      btn: 'View Employers',
    },
    {
      title: 'Jobseekers Created',
      value: 8,
      icon: <FaUsers />,
      btn: 'View Jobseekers',
    },
    {
      title: 'Jobs Posted',
      value: postcount,
      icon: <FaBriefcase />,
      btn: 'View Jobs',
    },
    {
      title: 'Wallet Balance',
      value: `$${walletAmount}`,
      icon: <FaWallet />,
      btn: 'Top Up Wallet',
    },
    {
      title: 'Subscription Plan',
      value: 'Premium',
      icon: <FaCrown />,
      btn: 'Manage Plan',
      endDate: 'Ends on: 30 June 2025',
    },
  ];

  return (
    <div>
      <h2 className="dashboard-title mb-4">Employer Dashboard</h2>
      <div className="row g-4 justify-content-center">
        {cards.map((card, i) => (
          <div className="col-md-4" key={i}>
            <div className="dashboard-card">
              <div className="icon-box">{card.icon}</div>
              <h5>{card.title}</h5>
              <p className="value">{card.value}</p>
              {card.endDate && <p className="subtext">{card.endDate}</p>}
              <button className="action-btn">{card.btn}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Employer_Dashboard;
